import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EnvioComponent } from './envio.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    EnvioComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    EnvioComponent
  ]
})

export class EnvioModule { }
